import { INITIAL_SEARCH_STATE } from ".";

export function makeSearchState(state) {
  // Takes some perhaps undefined or incomplete state and returns full search
  // state with defaults
  return { ...INITIAL_SEARCH_STATE, ...(state || {}) };
}
